<template>
<div :class="{heightPc : $mq==='pc',heightSp : $mq==='sp'}">
  <!--プロジェクト詳細-->
  <div class="d-flex flex-column">
    <project_about :pjuid="pjuid" :aboutpj="aboutpj" :pjadmins="pjadmins" @pjSetting="$emit('pjSetting')" @outPj="$emit('outPj')" @voteStart="$emit('voteStart')" @voteFinish="$emit('voteFinish')" @inLid="LidSankaAlert = true"></project_about>
    <div class="ma-0 px-2" :class="{'d-flex' : $mq==='pc'}">
      <p class="text-h6 font-weight-bold mb-0 mr-2" style="color:#2B2B2B;">最新の案</p>
      <v-btn class="rounded-pill px-4" width="auto" v-if="newpropj&&newpropj.amends&&newpropj.amends.length>0" @click="getAmends(),displaySomething = true"><span style="color:#707070;">採用された修正提案</span> <span style="color:#399942;" v-text="newpropj.amends.length+'件'"></span></v-btn>                
      <v-btn class="rounded-pill ml-auto px-6 mx-2" color="#399942" dark @click="getAmends(),displaySomething = true">案のみ表示</v-btn>
    </div>
    <v-btn v-if="oldpropj&&oldpropj.length>0&&oldpropj[0]" class="my-2 mr-auto abyss--text" text style="text-decoration: underline; font-size: large;" @click="displayOldpro=true,selectOldpro=oldpropj[0]">{{ newpropj.title }}時点の案（過去の案を見る）</v-btn>

    <div v-if="newpropj" class="px-8 overflow-y-auto mb-4">
      <RichViewer :key="newpropj.id" :fullPath="`projects/${lidid}/${pjuid}/proposal/${newpropj.id}.html`" @setData="setPjan"/>
    </div>
    
    <!--案編集ボタン-->
    <v-card-actions
      class="z1000"
      :class="{addAnPc : $mq==='pc',addAnSp : $mq==='sp'}"
      v-if="(aboutpj&&aboutpj.condition&&aboutpj.condition==='dis'&&!createPro&&(pjadmins&&pjadmins.some((el) => el === uid))||isAdmin)&&$mq!=='sp'"
    >
      <v-fab-transition>
        <v-btn
          color="#399942"
          fab
          large
          dark
          class="v-btn--example z1000"
          data-testid="gotoCreatePro"
          @click="createPro = true"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </v-fab-transition>
    </v-card-actions>

  </div>

  
  <!-- 最新の案表示画面 -->
  <v-dialog v-model="displaySomething" persistent class="pa-8 z1000" width="90vw" @keydown.esc="displaySomething = false" :fullscreen="$mq==='sp'">
    <v-card height="90vh" class="d-flex pt-0 px-2">
      <v-card height="75vh" width="40%" class="d-flex flex-column" elevation="0">
        <v-card-actions class="pb-0">
          <v-card-title class="text-subtitle-2 pt-2 pb-0 font-weight-medium" style="color:#707070">採用された修正提案一覧</v-card-title>
          <v-spacer></v-spacer>
        </v-card-actions>
        <p class="ml-6 mb-2" style="color:#399942" v-if="newpropj&&newpropj.amends"><span v-text="newpropj.amends.length"></span>件</p>
        <v-card-text class="text-center font-weight-bold" color="#2B2B2B" v-show="newpropj&&newpropj.amends&&newpropj.amends.length === 0">修正提案は採用されていません。</v-card-text>
        <v-card-text class="text-center font-weight-bold" color="#2B2B2B" v-show="newpropj&&newpropj.amends === null">修正提案は採用されていません。</v-card-text>
        <v-container id="scroll-target" style="max-height: 100%" class="overflow-y-auto">
          <v-col class="pa-0" v-scroll:#scroll-target="onScroll" align="start" justify="center">
            <v-row>
              <v-col v-for="amend in pjamendments" :key="amend.sort" cols="12">
                <v-card v-if="newpropj&&newpropj.amends&&newpropj.amends.includes(amend.id)">
                  <v-card elevation="0" style="border-radius: 0px; background-color:#399942;">
                    <v-list-item style="font-size:18px;">
                      <v-list-item-content class="mb-0" style="padding:0px"> 
                        <v-list-item-subtitle class="white--text text--lighten-2" style="height:40px; font-size:18px; display:flex; align-items:center;">
                          {{namelist[amend.author]}}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                  <v-card-text class="pa-2 overflow-y-auto" style="font-size: 100%; padding: 0px; max-height:20vh; color:#2B2B2B;"><span v-text="amend.content"></span><span v-if="amend.edit" style="font-size:6px; color:#707070;">  (編集済み)</span></v-card-text>
                  <v-card-actions class="d-flex justify-space-between">
                    <v-card-text class="pa-0">{{amend.day}} {{amend.hour}} </v-card-text> 
                    <div class="d-flex align-center">
                      <v-icon size="25">mdi-thumb-up</v-icon>
                      <v-card-text class="ml-2 pa-0 text-right">{{amend.like.length}}</v-card-text>
                    </div>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-container>
      </v-card>
      <v-card width="60%" elevation="0" class="overflow-y-auto">
        <v-card-actions>
          <v-card-title class="font-weight-bold text-h6 pa-2" style="color:#294A66">Ver.{{ newpropj.title }}</v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon color="primary" @click="displaySomething = false"><v-icon color="#E64550">mdi-close</v-icon></v-btn>
        </v-card-actions>
        <RichViewer ref="viewer" :key="newpropj.id" :fullPath="`projects/${lidid}/${pjuid}/proposal/${newpropj.id}.html`" />
      </v-card>
    </v-card>
  </v-dialog>

  <!-- 過去の案表示画面 -->
  <v-dialog v-model="displayOldpro" persistent class="pa-2 z1000" width="90vw" @keydown.esc="displaySomething = false" :fullscreen="$mq==='sp'">
    <v-card height="90vh" style="overflow:hidden hidden">
      <v-card-actions>
        <h2>過去の案</h2>
        <v-spacer></v-spacer>
        <v-icon color="deepLava" @click="displayOldpro=false">mdi-close</v-icon>
      </v-card-actions>
      <v-row class="px-2 ma-0">
        <v-col cols="3" style="max-height:90vh;" class="overflow-y-auto">
          <v-list>
            <v-list-item-group mandatory>
              <v-list-item v-for="item in oldpropj" :key="item.sort" @click="selectOldpro=item">
                <v-list-item-content>
                  <v-list-item-title>
                    <span v-if="item&&item.date2">Ver.{{ item.date2 }}</span>
                    <span v-else>Ver.{{ item.sort }}</span>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-col>
        <v-col cols="9" :style="$mq === 'pc' ? 'max-height:85vh' : 'max-height:98vh'" class="overflow-y-auto">
          <h3><span v-if="selectOldpro&&selectOldpro.date2">Ver.{{ selectOldpro.date2 }}</span><span v-else-if="selectOldpro&&selectOldpro.sort">Ver.{{ selectOldpro.sort }}</span></h3>
          <div class="" style="max-height:90%; overflow:hidden scroll !important;">
            <RichViewer :key="selectOldpro.id" :fullPath="`projects/${lidid}/${pjuid}/proposal/${selectOldpro.id}.html`" style="font-size:15px;" />
          </div>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>

  <!--個人プロフィール-->
  <v-dialog v-model="profile" width="50vw" class="z1000">
    <profile :theProfile="theProfile"></profile>
  </v-dialog>

  <!--案を作る-->
  <v-dialog v-model="createPro" class="ma-0 pa-0 z1000" height="90vh" width="90vw" :fullscreen="$mq==='sp'">
    <addpro :key="pjuid" class="ma-0 pa-0" :pjuid="pjuid" :aboutpj="aboutpj" :pjadmins="pjadmins" :pjusers="pjuser" :pjan="pjan" @closeAddPro="closecreatePro" @updateAn="$emit('updateAn')"></addpro>
  </v-dialog>

  <!--プロジェクト終了確認通知-->
  <v-dialog v-model="ProFinCheck" width="60%" class="z1000">
    <v-card class="pa-4">
      <v-card-text class="text-center pt-8 ma-2 pa-2 text-h5 font-weight-bold" style="color:#0F0101;">
        <v-img class="dog" max-height="100%" max-width="8%" src="../../assets/svg/5007red.svg"></v-img>
        本当に{{$t('プロジェクト')}}を終了しますか？
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-chip class="ma-4 pa-4 font-weight-bold" color="#66baff" @click="endPj(),noticePjFin=true,ProFinCheck=false" dark>はい</v-chip>
        <v-chip class="ma-4 pa-4 font-weight-bold" color="#E64550" @click="ProFinCheck=false" dark>いいえ</v-chip>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!--プロジェクト終了通知画面-->
  <v-dialog v-model="noticePjFin" width="60%" class="z1000">
    <v-card class="pt-4 pb-2">
      <v-card-text class="text-center px-8 py-2 text-h5 font-weight-bold" style="color:#0F0101;">この{{$t('プロジェクト')}}は終了しました</v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-chip class="mt-4 mx-2 px-4" @click="noticePjFin=false,reload()" color="#66BAFF" dark>確認</v-chip>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!--Lid参加確認画面-->
  <v-dialog v-model="LidSankaAlert" width="800" class="z1000">
    <v-card elevation="15" class="pt-6">
      <v-card-actions class="d-flex justify-center align-center">
        <v-img class="mr-4" max-height="100%" max-width="8%" src="../../assets/svg/5007red.svg"></v-img>
        <div>
          <p class="font-weight-bold text-h5 text-center">あなたはこのLidに参加していません。</p>
          <p class="font-weight-bold text-h5 text-center mb-0">このLidに参加しますか？</p>        
        </div>
      </v-card-actions>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-chip class="ma-4 pa-4" @click="LidSankaAlert = false" >参加しない</v-chip>
        <v-chip class="ma-4 pa-4" @click="LidSankaAlert = false, $store.dispatch('inLid',{lidId:$route.params.id,uid:uid})" color="deepAqua" dark>参加</v-chip>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import Vue from 'vue'
import firebase from "firebase/app"
import "firebase/firestore"
import VueDOMPurifyHTML from 'vue-dompurify-html'
import project_about from './project_about.vue'
import profile from '../../components/profile.vue'
import RichViewer from '../RichViewer.vue'
import addpro from './addpro.vue'
Vue.use(VueDOMPurifyHTML)
import VueMq from 'vue-mq'
Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sp: 959,
    pc: 960
  },
  defaultBreakpoint: 'pc' // customize this for SSR
})
export default{
  components:{
    project_about,
    profile,
    addpro,
    RichViewer
  },
  props:{
    lidid: String,
    pjuid: String,
    modeVote: Boolean,
    modeResult: Boolean,
    pjadmins: Array,
    aboutpj: Object,
    newpropj: Object,
    oldpropj: Array,
    pjuser: Array,
  },
  data: (vm) => ({
    db: null,
    //dialog
    LidSankaAlert: false,
    editpj: false,
    displayTitle: "",
    displaySomething: false,
    displayOldpro:false,
    ProFinCheck: false,
    profile: false,
    pjamendments:[],
    candiAdmin: [],
    addAdmin: false,
    deleAdmin: false,
    noticePjFin: false,
    theProfile: null,
    createPro: false,
    offsetTop: 0,
    selectOldpro: {},
    pjan: '',
    answer: '',
    question: '',
  }),
  computed:{
    members(){
      return this.$store.state.members
    },
    namelist(){
      return this.$store.state.namelist
    },
    isAdmin() {
      return this.$store.state.isAdmin
    },
    uid(){
      return this.$store.state.auth?.user?.uid || '';
    },
  },
  mounted(){
    this.db = firebase.firestore() // dbインスタンスを初期化
  },
  methods: {
    setPjan(content) {
      this.pjan = content
    },
    reload(){
      this.$router.go({path: this.$router.currentRoute.path, force: true})
    },
    onScroll (e) { //スクロール
      this.offsetTop = e.target.scrollTop
    },
    closecreatePro(el){
      this.createPro = el
    },
    setProfile(item){
      this.theProfile = this.members.filter(function(el) {
        return el.id == item
      }).shift()
    },
    scrollBottom() { //スクロール
      //window.scrollToだと後ろの画面が動いてしまう
      this.$nextTick(() => {
        window.scrollTo(0, document.body.scrollHeight)
      })
    },
    getAmends(){
      this.pjamendments = []
      const self = this
      this.db.collection("0").doc(this.$route.params.id).collection("project").doc(this.pjuid).collection('amendments').orderBy('createdAt').where("isActive","==",true).get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          //console.log(`${doc.id} => ${doc.data()}`)
          let oneamend = doc.data()
          self.$set(oneamend,"id",doc.id)
          self.pjamendments.push(oneamend)
        })
      })
    },
    //Base管理者追加
    addAdmins(){
      let self = this
      self.db.collection("0").doc(this.$route.params.id).collection("project").doc(this.pjuid).collection("user").doc("admin").update({
        pjadminuid: firebase.firestore.FieldValue.arrayUnion(...Object.values(self.candiAdmin))
      }).then(function(docRef) {
        // 保存に成功した時
        //console.log("USERss Document written with ID: ", docRef.id)
        //console.log("追加管理者登録完了")
        self.candiAdmin = []
        self.$emit("getpjusers",true)
      }).catch(function(error) {
        // 保存に失敗した時
        console.error("追加管理者登録失敗: ", error)
        alert("Error!:"+error)
      })
    },
    //Base管理者削除
    deleAdmins(){
      let self = this
      self.db.collection("0").doc(this.$route.params.id).collection("project").doc(this.pjuid).collection("user").doc("admin").update({
        pjadminuid: firebase.firestore.FieldValue.arrayRemove(...Object.values(self.candiAdmin))
      }).then(function(docRef) {
        // 保存に成功した時
        //console.log("USERss Document written with ID: ", docRef.id)
        //console.log("追加管理者削除完了")
        self.candiAdmin = []
        self.$emit("getpjusers",true)
      }).catch(function(error) {
        // 保存に失敗した時
        console.error("追加管理者削除失敗: ", error)
        alert("Error!:"+error)
      })
    },
    //プロジェク状態変更関係関数
    endPj(){
      this.db.collection("0").doc(this.$route.params.id).collection("project").doc(this.pjuid).update({
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        isActive: false,
        removeReason: "プロジェクト終了ボタンを押下"
      })
    },
  }
}
</script>

<style scoped>
.heightPc{
  max-height:100%;
  width:100%;
  overflow:hidden scroll;
}
.heightSp{
  width:100%;
  overflow:hidden scroll;
}
.addAnPc{
  position:absolute;
  bottom:10px;
  right:10px;
}
.addAnSp{
  position:fixed;
  bottom:10px;
  right:10px;
}
.deepalgaeFont{
  background-color: #399942;
}
.lavaFont{
  background-color: #E64550;
}
.close{
  position: fixed;
  right: 1%;
  top: 1%;
  width: 4%;
}
.dog{
  position: absolute;
  top: 20%;
  left: 5%;
}
*{
  font-family:mplus-2c-medium;
}
.an::-webkit-scrollbar {
  display: none;
}
/*
::-webkit-scrollbar {
  display: none;
}
::-webkit-scrollbar-track {
background-color: rgba(120, 170, 210,0.3);
border-radius: 100px;
}
::-webkit-scrollbar-thumb {
background: #78aad2;
border-radius: 100px;
width: 130px;
}
*/
</style>
